import { ArticleHeading1, ArticleHeading2, Button, Modal, Responsive, Input, Textarea, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ReplyTemplateModalCreate.css';

type TProps = {
  initialText: string | null;
  isLoading: boolean;
  errorMessage?: string;
  onCreate: (text: string, name?: string) => void;
  onClose: () => void;
};

export const ReplyTemplateModalCreate: React.FC<TProps> = ({
  initialText,
  isLoading,
  errorMessage,
  onClose,
  onCreate,
}) => {
  const [name, setName] = React.useState<string>('');
  const [text, setText] = React.useState<string>('');

  React.useEffect(() => {
    if (initialText) {
      setText(initialText);
    }
  }, [initialText]);

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const onChangeText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  };

  return (
    <Modal
      open
      size="S"
      onOpenChange={onClose}
      header={
        <>
          <Responsive desktop>
            <ArticleHeading1>Новый шаблон ответа</ArticleHeading1>
          </Responsive>
          <Responsive phone tablet>
            <ArticleHeading2>Новый шаблон ответа</ArticleHeading2>
          </Responsive>
        </>
      }
      footer={
        <>
          <Responsive desktop>
            <div className={styles['buttons-desktop']}>
              <Button theme="fill_secondary" size="M" onClick={onClose}>
                Отмена
              </Button>
              <Button size="M" onClick={() => onCreate(text, name)} disabled={!text.trim()} loading={isLoading}>
                Создать
              </Button>
            </div>
          </Responsive>
          <Responsive phone tablet>
            <div className={styles['buttons-mobile']}>
              <Button theme="fill_secondary" size="M" fullWidth onClick={onClose}>
                Отмена
              </Button>
              <Button
                size="M"
                fullWidth
                onClick={() => onCreate(text, name)}
                disabled={!text.trim()}
                loading={isLoading}
              >
                Создать
              </Button>
            </div>
          </Responsive>
        </>
      }
    >
      <>
        <Responsive desktop>
          <div className={styles['container-desktop']}>
            <Input
              maxLength={40}
              value={name}
              size="M"
              onChange={onChangeName}
              placeholder="Название шаблона (необязательно)"
            />
            <Textarea
              value={text}
              size="M"
              onChange={onChangeText}
              hasCounter
              minRows={5}
              maxRows={10}
              placeholder="Текст шаблона"
              maxLength={1000}
            />
            <UIText2 color="theme-red">{errorMessage}</UIText2>
          </div>
        </Responsive>
        <Responsive phone tablet>
          <div className={styles['container-mobile']}>
            <Input
              maxLength={40}
              value={name}
              size="M"
              onChange={onChangeName}
              placeholder="Название шаблона (необязательно)"
            />
            <Textarea
              value={text}
              size="M"
              onChange={onChangeText}
              hasCounter
              minRows={5}
              maxRows={10}
              placeholder="Текст шаблона"
              maxLength={1000}
            />
            <UIText2 color="theme-red">{errorMessage}</UIText2>
          </div>
        </Responsive>
      </>
    </Modal>
  );
};
